<template>
    <div style="display: flex; padding: 0 12px; overflow-x: scroll; gap: 15px; padding-bottom: 5px; padding-top: 2px;" class="hide_scroll">
        <div @click="$Util.showProfile(each.idx, 0)" v-for="each, i in userList" :key="i" style="border: 1px solid #8080801A; box-shadow: 2px 2px 4px 0px #210F031A; text-align: center; border-radius: 12px; padding: 13px; min-width: 157px;">
            <RecommendUser :memberInfo="each"></RecommendUser>
        </div>
    </div>
</template>

<script>
import RecommendUser from '@/components/common/RecommendUser'

export default {
    name: 'RecommendFriendsWrapper',
    components: { RecommendUser },
    props: {
        userList: {
            type: Array,
            default: () => {}
        }
    },
    data() {
        return {

        }
    },
    methods: {

    },
}
</script>

<style scoped>
.ellipsis {
    text-overflow: ellipsis;
    overflow: hidden;
    -webkit-line-clamp: 1;
    display: -webkit-box;
    -webkit-box-orient: vertical
}
</style>